import { Component } from '@angular/core';
import { KundeService } from '../service';

@Component({
  selector: 'fa-kt-saved-kunde-filters',
  templateUrl: './saved-kunde-filters.component.html',
  styleUrls: ['./saved-kunde-filters.component.css'],
})
export class SavedKundeFiltersComponent {
  constructor(public kunde: KundeService) {}
  /* << fields   */

  /*   fields >> */
  /* << methods   */

  /*   methods >> */
}
